import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "trailreactions",
  style: {"margin-top":"14px"}
}
const _hoisted_2 = { class: "mrbox nofill border round whitefill" }
const _hoisted_3 = { style: {"width":"100%","margin":"0px 0px 16px 0px"} }
const _hoisted_4 = {
  key: 0,
  style: {"vertical-align":"top","width":"168px","text-align":"center"}
}
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { style: {"vertical-align":"top","padding-left":"8px","padding-right":"8px"} }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"bold"} }, "Reactie", -1)
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { style: {"font-style":"italic","margin-top":"8px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", null, _toDisplayString(_ctx.listTitle), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reactions, (reaction) => {
      return (_openBlock(), _createElementBlock("div", {
        key: reaction.id
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", null, [
            _createElementVNode("span", null, _toDisplayString(reaction.date), 1),
            _createTextVNode("   "),
            _createElementVNode("span", {
              class: _normalizeClass('rating star' + reaction.stars),
              style: {"font-size":"14px","display":"inline"}
            }, " ", 2)
          ]),
          _createElementVNode("table", _hoisted_3, [
            _createElementVNode("tr", null, [
              (reaction.imageCode)
                ? (_openBlock(), _createElementBlock("td", _hoisted_4, [
                    _createElementVNode("a", {
                      class: "rtimg",
                      href: reaction.imageUrl
                    }, [
                      _createElementVNode("img", {
                        src: reaction.imageUrl,
                        alt: "foto",
                        style: {"max-width":"145px","max-height":"145px","border-radius":"4px"}
                      }, null, 8, _hoisted_6)
                    ], 8, _hoisted_5)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("td", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", {
                  innerHTML: reaction.description
                }, null, 8, _hoisted_9),
                _createElementVNode("div", _hoisted_10, "Door " + _toDisplayString(reaction.name), 1)
              ])
            ])
          ])
        ])
      ]))
    }), 128))
  ]))
}